import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PricingCards from "@/components/site/PricingCards";
import { HOME_TEXT as T } from "@/data/content";

export default function PricingShowcase() {
  return (
    <section className="sec relative overflow-hidden bg-p-mist text-slate-700">
      <div className="wrap relative">
        <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <div className="max-w-xl">
            <p className="eyebrow">Pacchetti</p>
            <h2 className="h-section mt-3">{T.pricing_title} <span className="hl-light">{T.pricing_highlight}</span></h2>
            <p className="mt-2 text-slate-600">{T.pricing_subtitle}</p>
          </div>
          <Link to="/prezzi" data-testid="home-pricing-link" className="link-arrow">Dettagli e condizioni <ArrowRight className="h-4 w-4" /></Link>
        </div>
        <div className="mt-6 sm:mt-10"><PricingCards compact /></div>
      </div>
    </section>
  );
}
